import { useCallback, useEffect, useState } from 'react';

import type { PricingOptionIndex } from '../../types';

import type { OtaSummaryOption } from './types';

export type OtaSummaryOptions = Partial<Record<PricingOptionIndex, OtaSummaryOption>>;

export interface SavedOtaSummary {
  options: Record<string, OtaSummaryOption>;
}

const NO_OPTIONS: OtaSummaryOptions = {};

export function useOtaSummary(offerId: string | undefined) {
  const [options, setOptions] = useState<OtaSummaryOptions>(NO_OPTIONS);

  useEffect(() => {
    setOptions(NO_OPTIONS);
  }, [offerId]);

  const replaceOption = useCallback(
    (option: PricingOptionIndex, summary: OtaSummaryOption) =>
      setOptions((current) => ({ ...current, [option]: summary })),
    [],
  );

  const loadDraft = useCallback((saved: SavedOtaSummary) => setOptions(saved.options), []);

  return { options, replaceOption, loadDraft };
}
